
import moment from "moment";
import { getFormattedTime } from "@/src/helpers/getFormattedTime";
import OriginDest from "../OriginDest";

export default function OriginDestinationItem({
  i,
  od,
  countryList,
}) {
  const toatlFlightTime = (flights) => {
    let totalTimeInSecs = 0;
    flights.forEach((flt) => {
      totalTimeInSecs += parseInt(flt.ElapsedTime);
    });
    return <span>{getFormattedTime(totalTimeInSecs)}</span>;
  };
  return (
    <div className="p-4">
      <div className="flex gap-x-3 ">
        <div className="">
          <div className="flex gap-x-3">
            {od.FlightDetails.map((fd, i) => {
              return (
                <img
                  key={fd.FlightNumber + fd.AirEquipType + i + "_id"}
                  id={fd.FlightNumber + fd.AirEquipType + i + "_id"}
                  src={fd.Logo}
                  alt=""
                  className="w-6 h:6 md:w-12 md:h-12 rounded object-contain"
                />
              );
            })}
          </div>
        </div>
        <div className="flex-1">
          <div className="flex items-center text-sm gap-x-1">
            <span>{i == 1 ? "Return" : "Departure"}</span>
            <span className="block">•</span>
            <span>{moment(od.DepartureDateTime).format("lll")}</span>
          </div>
          <div className="flex items-center text-xs lg:text-sm gap-x-1 text-muted-foreground">
            <span>
              {od.Origin} - {od.Destination}
            </span>
            <span className="block">•</span>
            <span>
              {toatlFlightTime(od.FlightDetails)} (
              {od.FlightDetails.length == 1
                ? "Non Stop"
                : od.FlightDetails.length - 1 + " Stop"}
              )
            </span>
          </div>
        </div>
      </div>

      <OriginDest key={od.Origin + i} od={od} countryList={countryList} />
    </div>
  );
}
